import React, { createContext, useState, useCallback } from 'react';
import SubscriptionService from '../services/SubscriptionService';

export const OnlinePurchaseContext = createContext();

export default function OnlinePurchaseProvider(props) {
  const [isLoading, setLoading] = useState(false);
  const [subscriptionsAndAddons, setSubscriptionsAndAddons] = useState(null);
  const [purchaseData, setPurchaseData] = useState({
    subscription: null,
    add_ons: [],
    amount: 0,
    payable: 0,
    tax: 0,
    shop_details: null,
  });

  const loadSubscriptionsAndAddons = useCallback(async () => {
    if (subscriptionsAndAddons) return;
    setLoading(true);
    try {
      const resp = await SubscriptionService.getSubscriptionsAndAddons();
      const normalized = resp?.data ?? resp;
      setSubscriptionsAndAddons(normalized);
    } catch (err) {
      console.error('Failed to load subscriptions/addons', err);
    } finally {
      setLoading(false);
    }
  }, [subscriptionsAndAddons]);

  return (
    <OnlinePurchaseContext.Provider
      value={{
        isLoading,
        purchaseData,
        subscriptionsAndAddons,
        setPurchaseData,
        loadSubscriptionsAndAddons,
      }}
    >
      {props.children}
    </OnlinePurchaseContext.Provider>
  );
}
